import { render, staticRenderFns } from "./ThirdPersonAssurancesWidget.vue?vue&type=template&id=0a37ff58&scoped=true"
import script from "./ThirdPersonAssurancesWidget.vue?vue&type=script&lang=js"
export * from "./ThirdPersonAssurancesWidget.vue?vue&type=script&lang=js"
import style0 from "./ThirdPersonAssurancesWidget.vue?vue&type=style&index=0&id=0a37ff58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a37ff58",
  null
  
)

export default component.exports